import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PedidosProduzirService} from '../../services/pedidos-produzir.service';

@Component({
  selector: 'app-producao-status-pedido', standalone: true, imports: [CommonModule, FormsModule],
  templateUrl: './producao-status-pedido.component.html',
  styleUrls: ['../producao-pedido/producao-pedido.component.scss']
})
export class ProducaoStatusPedidoComponent implements OnChanges, OnDestroy {
  @Input() pedidoId: number;
  @Input() statusDestino: number;
  itens: any[] = [];
  comissionados: any[] = [];
  labelComissionado = 'Comissionado';
  moduloComissionamentoAtivo = false;
  carregando = false;
  salvando = false;
  erro = '';
  private consulta = 0;

  constructor(private service: PedidosProduzirService) {}

  async ngOnChanges() {
    const consulta = ++this.consulta;
    this.itens = [];
    this.erro = '';
    if(!this.pedidoId || ![1, 2].includes(Number(this.statusDestino))) return;
    this.carregando = true;
    try {
      const [producoes, opcoes] = await Promise.all([
        this.service.listeProducoesDoPedido(this.pedidoId), this.service.opcoesProducao()]);
      if(consulta !== this.consulta) return;
      if(!opcoes.producaoPedidosAtiva) return;
      this.moduloComissionamentoAtivo = opcoes.moduloComissionamentoAtivo;
      this.comissionados = opcoes.comissionados;
      const nome = String(opcoes.comissionadoLabel || 'Comissionado').trim();
      this.labelComissionado = nome.toLowerCase().endsWith('s') ? nome.slice(0, -1) : nome;
      this.itens = producoes.filter((p: any) => !p.consumo && p.status !== 'cancelada' && !p.itemRemovido &&
        (Number(this.statusDestino) === 2 || !p.atendimento ||
          (p.atendimento === 'produzir' && this.moduloComissionamentoAtivo && !this.comissionados.some(c => Number(c.id) === Number(p.comissionado?.id)))))
        .map((p: any) => ({...p, atendimento: p.atendimento || 'produzir', fichaId: p.ficha?.id || null,
          comissionadoId: p.comissionado?.id || null}));
      for(const p of this.itens) this.ajusteFichaAoMudarAtendimento(p);
    } catch(erro) {
      if(consulta === this.consulta) this.erro = String(erro?.message || erro);
    } finally { if(consulta === this.consulta) this.carregando = false; }
  }

  ajusteFichaAoMudarAtendimento(p: any) {
    p.fichas = JSON.parse(p.alternativas).filter((f: any) => p.atendimento !== 'vitrine' || f.tipo === 'produto-beneficiado');
    p.semBaixaEstoque = p.atendimento === 'vitrine' && !p.fichas.length;
    if(p.fichas.length === 1) p.fichaId = p.fichas[0].id;
    else if(!p.fichas.some((f: any) => Number(f.id) === Number(p.fichaId))) p.fichaId = null;
  }

  async prepareStatus(): Promise<void> {
    if(this.carregando || this.salvando) throw new Error('Aguarde o carregamento da produção.');
    if(this.erro) throw new Error(this.erro);
    for(const p of this.itens.filter(p => !p.consumo)) {
      if(Number(this.statusDestino) === 1) {
        if(!['produzir', 'vitrine'].includes(p.atendimento)) throw new Error(`Selecione o atendimento de ${p.itemPedido.descricao}.`);
        if(p.atendimento === 'produzir' && this.moduloComissionamentoAtivo && !this.comissionados.some(c => Number(c.id) === Number(p.comissionadoId)))
          throw new Error(`Selecione ${this.labelComissionado.toLowerCase()} de ${p.itemPedido.descricao}.`);
      } else {
        if(Number(p.pedido.status) !== 1) throw new Error('Entre em preparação antes de concluir a produção.');
        if(!p.semBaixaEstoque && !p.fichas.some((f: any) => Number(f.id) === Number(p.fichaId)))
          throw new Error(`Selecione a ficha / receita de ${p.itemPedido.descricao}.`);
      }
    }
    this.salvando = true;
    try {
      for(const p of this.itens.filter(p => !p.consumo)) {
        const salvo: any = await this.service.salveProducao(p.id, {versao: p.versao,
          atendimento: p.atendimento, comissionado: p.atendimento === 'produzir' && p.comissionadoId ? {id: p.comissionadoId} : null,
          ficha: p.fichaId ? {id: p.fichaId} : null,
          prazo: p.prazo || null, areaDestino: p.atendimento === 'produzir' ? p.areaDestino || null : null});
        Object.assign(p, salvo);
        if(Number(this.statusDestino) === 2) {
          const concluido = await this.service.concluaProducao(p.id, {versao: p.versao, areaDestino: p.areaDestino || null});
          Object.assign(p, concluido);
        }
      }
      this.itens = [];
    } finally { this.salvando = false; }
  }

  ngOnDestroy() { this.consulta++; }
}
